import React from 'react'
// libs
import styled from 'styled-components'
// components
import InputLabelComponent, { InputLabelProps } from '@mui/material/InputLabel'
// static
import Asterisk from '@mui/icons-material/Emergency'
// themes
import { colors } from 'themes/index'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import { size } from 'polished'

export const AsteriskIcon = styled(Asterisk)`
  && {
    ${size('12px')};
    min-width: 12px;
    fill: ${colors.red300};
  }
`

interface Props extends InputLabelProps {
  label?: string
  required?: boolean
}

const InputLabel: React.FC<Props> = ({ label, required, children, ...rest }) => {
  const { isRisk, isRiskTemplate } = React.useContext(RiskTemplateAPIContext)

  return (
    <InputLabelComponent {...rest} variant='standard'>
      {(isRisk || isRiskTemplate) && required && <AsteriskIcon />}
      {label}
      {children}
    </InputLabelComponent>
  )
}
export default InputLabel
